import { Table, TableContainer } from '@ksyos/design-system';
import type { FundingErrorInformation } from '@common/enums';
import type { Financing } from '../financing';
import { FinancingTableOldBody } from './FinancingTableOldBody';
import { FinancingTableOldHeader } from './FinancingTableOldHeader';

type FinancingTableOldProps = {
    allFinanceItemsSelected: boolean;
    items: Financing[];
    onChangeFundingErrorInformation: (value: FundingErrorInformation | null, financingItemIndex: number) => void;
    onSelectAllFinanceItems: (value: boolean) => void;
    onSelectFinancingItem: (id: string, value: boolean) => void;
    reprocessedActivities: string[];
};

export function FinancingTableOld(props: FinancingTableOldProps) {
    const {
        reprocessedActivities,
        items,
        onSelectAllFinanceItems,
        allFinanceItemsSelected,
        onChangeFundingErrorInformation,
        onSelectFinancingItem,
    } = props;

    return (
        <TableContainer>
            <Table>
                <FinancingTableOldHeader
                    allFinanceItemsSelected={allFinanceItemsSelected}
                    items={items}
                    onSelectAllFinanceItems={onSelectAllFinanceItems}
                />
                <FinancingTableOldBody
                    items={items}
                    onChangeFundingErrorInformation={onChangeFundingErrorInformation}
                    onSelectFinancingItem={onSelectFinancingItem}
                    reprocessedActivities={reprocessedActivities}
                />
            </Table>
        </TableContainer>
    );
}
